import React from 'react'
import PropTypes from 'prop-types'
import { Radio } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import StandardFieldLabel from '../formFieldWrapper/standardFieldLabel'
import { withApplicationTheme } from '../../applicationTheme'
import { getThemedCompact } from '../util'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const BaseRadioField = ({
  elmId = 'base_radio_field',
  size,
  className = '',
  label,
  compact = undefined,
  theme = undefined,
  ...rest
}) => {
  let newCompact = getThemedCompact(theme, compact)
  if (typeof size !== 'undefined') {
    newCompact = size === 'small'
  }

  const labelProps = {
    checkboxType: 'radio',
    compact: newCompact,
    className,
    elmId,
  }

  const standardLabel = StandardFieldLabel.createFromLabel(label, labelProps)

  return (
    <Radio
      data-elm-id={`${elmId}_radio_option`}
      className={cx('root', className, { medium: !newCompact })}
      label={standardLabel}
      {...rest}
    />
  )
}

BaseRadioField.propTypes = {
  className: PropTypes.string,
  elmId: PropTypes.string,
  size: PropTypes.string, // deprecated but here for backward compatibility
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  compact: PropTypes.bool,
  theme: PropTypes.object,
}

export default withApplicationTheme(BaseRadioField)
